module.exports = __webpack_public_path__ + "static/Keyboard-fd399c79685163a8ff3b67c343a6614a.png";